<template>
  <div v-if="btn.external">
    <a
      :href="btn.link"
      target="_blank"
      rel="noopener"
      class="btn__wrapper"
    >
      <div v-if="btn[lang].textPrimary" class="btn__wrapper__text">
        <bdi>{{ btn[lang].textPrimary }}</bdi>
      </div>
      <div class="btn" v-if="btn.symbol"
        data-mouse
        data-mouse-attractionstate="active"
        data-mouse-attractionval="20"
        data-mouse-magnetism="5"
        data-hover-type="zoom"
      >
        <img :src="`/static/img/btns/${btn.symbol}.svg`" class="btn__img" alt="button icon" />
        <div class="btn__border">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 44"><path d="M18.5.6c1.5 0 7.9.1 9.5.2 2.2.2 4.8 1.2 6.2 1.8 7.4 3.2 9.6 12.1 9.6 20.3 0 1.7-.3 3.2-.6 4.8-.5 2.5-1.7 4.8-3 7.1-1.2 2-3.2 4.2-5.2 5.5-3.4 2.2-7.9 3.2-12.3 3.2s-7.9-1.5-11.3-3.7c-2.8-1.8-5.1-4-6.8-6.8-1.6-2.9-3.2-6.2-3.2-9.7 0-4.4.5-10.2 3-13.5 1.2-1.8 3-4.1 5-5.4 1.1-.8 2.7-1.7 3.6-2.1 1.2-.6 2.5-1.4 3.8-1.8" fill="none" stroke="#000" stroke-width=".85" stroke-linecap="round" stroke-miterlimit="10"/></svg>
        </div>
      </div>
      <div v-if="btn[lang].textAlt" class="btn__wrapper__text">
        <bdi>{{ btn[lang].textAlt }}</bdi>
      </div>
    </a>
  </div>
  <div v-else>
    <router-link
      :to="btn.link"
      class="btn__wrapper"
    >
      <div v-if="btn[lang].textPrimary" class="btn__wrapper__text">
        <bdi>{{ btn[lang].textPrimary }}</bdi>
      </div>
      <div class="btn" v-if="btn.symbol"
        data-mouse
        data-mouse-attractionstate="active"
        data-mouse-attractionval="20"
        data-mouse-magnetism="5"
        data-hover-type="lang"
      >
        <img :src="`/static/img/btns/${btn.symbol}.svg`" class="btn__img" alt="button icon" />
        <div class="btn__border">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 44"><path d="M18.5.6c1.5 0 7.9.1 9.5.2 2.2.2 4.8 1.2 6.2 1.8 7.4 3.2 9.6 12.1 9.6 20.3 0 1.7-.3 3.2-.6 4.8-.5 2.5-1.7 4.8-3 7.1-1.2 2-3.2 4.2-5.2 5.5-3.4 2.2-7.9 3.2-12.3 3.2s-7.9-1.5-11.3-3.7c-2.8-1.8-5.1-4-6.8-6.8-1.6-2.9-3.2-6.2-3.2-9.7 0-4.4.5-10.2 3-13.5 1.2-1.8 3-4.1 5-5.4 1.1-.8 2.7-1.7 3.6-2.1 1.2-.6 2.5-1.4 3.8-1.8" fill="none" stroke="#000" stroke-width=".85" stroke-linecap="round" stroke-miterlimit="10"/></svg>
        </div>
      </div>
      <div v-if="btn[lang].textAlt" class="btn__wrapper__text">
        <bdi>{{ btn[lang].textAlt }}</bdi>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TweenLite } from 'gsap/TweenLite';

import { qs } from '@/scripts/utils';


export default {
  name: 'Cta',

  props: ['btn'],

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),
  },

  mounted() {
    this.$el.style.opacity = 0;
    const border = qs('.btn__border', this.$el);

    this.setDashoffset(border);
  },

  methods: {
    setDashoffset(line) {
      const path = qs('svg path', line);

      const dashoffset = Math.ceil(path.getTotalLength());
      const dasharray = Math.ceil(path.getTotalLength());

      TweenLite.set(path, {
        strokeDashoffset: dashoffset,
        strokeDasharray: dasharray,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../application';

$pd: 20px;
$pd2: $pd * 2;

.btn {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
  padding: 9px;
  overflow: hidden;

  @include mq(sm) {
    padding: $pd $pd;
    width: 84px;
    height: 84px;
  }
 
  &__border {
    position: absolute;
    top: 1px;
    left: 0;
    width: 100%;
    height: 100%;
 
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      width: calc(100% - 20px);
      height: calc(100% - 20px);
 
      transform: translate3d(-50%, -50%, 0);

      @include mq(sm) {
        width: calc(100% - 40px);
        height: calc(100% - 40px);
      }
    }
  }
 
  &__img {
    width: 60%;
    height: 60%;
    margin-top: 20%;
    vertical-align: sub;
 
    transition: transform 0.4s ease-out;
  }
 
  &__wrapper {
    @extend %flex;
    align-items: center;
 
    &__text {
      overflow: hidden;
      bdi {
        display: inline-block;
      }
    }
 
  }
 
  cursor: url(/static/vector/cursor-pointer.png), default !important;
 
  &:hover {
    .btn__img {
      transform: scale(0.85);
    }
  }
}
</style>

<style lang="scss">
@import '../../application';

.btn--back {
  .btn__wrapper__text {
    display: none;
  }
  
  @include mq(sm) {
    .btn__wrapper__text {
      display: block;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/utils/Cta.vue